import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { ROLE_PERMISSIONS, UserRole, RolePermissions } from '../types/Role';

export const usePermissions = (): RolePermissions => {
  const { user } = useContext(AuthContext);
  
  // Default to sales role if no role is set
  const userRole = (user?.role as UserRole) || 'sales';
  
  return ROLE_PERMISSIONS[userRole] || ROLE_PERMISSIONS.sales;
};

export const useRole = (): UserRole => {
  const { user } = useContext(AuthContext);
  return (user?.role as UserRole) || 'sales';
};
